module.exports = __webpack_public_path__ + "static/img/who-we-are__small.0fefebd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/primary/who-we-are__small.jpg
// module id = uRsV
// module chunks = 1